<template>
  <div>
    <div v-for="(lot, index) in lotList" :key="lot.id" class="active-lot-detail cursor-pointer-div"
         @click="toLotDetail(lot)">
      <div class="lot-number-title">标的{{ index + 1 }}</div>
      <!--<span class="active-lot-sort">
        {{lot.sort}}
      </span>-->

      <!-- 图片/视频显示区域 -->
      <div class="media-container">
        <!-- 如果是视频 -->
        <div v-if="isVideoFile(lot.lotImg[0].link)" class="video-thumbnail-wrapper">
          <video
              :src="lot.lotImg[0].link"
              class="active-lot-img video-thumbnail"
              muted
              playsinline
              preload="metadata"
              @loadeddata="onVideoThumbLoaded(lot.id, $event)"
          ></video>
          <div class="video-play-icon">
            <i class="el-icon-video-play"></i>
          </div>
        </div>
        <!-- 如果是图片 -->
        <img v-else :src="lot.lotImg[0].link" class="active-lot-img">
      </div>

      <span class="active-lot-name">{{ lot.lotName }}</span>
      <div>
        <span v-if="lot.auctionStatus!=null" class="active-lot-label-status">{{
            lot.auctionStatus == 0 ? '未开始' : (lot.auctionStatus == 1 || lot.auctionStatus == 2 ? '进行中' :
                (lot.auctionStatus == 3 ? '已成交' : (lot.backOutStatus == 1 ? '已撤拍' : '已流拍')))
          }}&nbsp;</span>
        <span v-if="lot.auctionStatus!=-1 "
              :style="lot.auctionStatus==0?'color: rgba(30, 169, 106, 1);':'color:rgba(214, 54, 59, 1)'"
              class="acitve-lot-price">{{
            lot.auctionStatus == 0 ? parseFloat(lot.startPrice).toFixed(2) : parseFloat(lot.currentQuoted).toFixed(2)
          }}{{ getPriceUnit(lot) }}</span>
      </div>
      <div class="active-lot-time-div">
        <span class="active-lot-time-left">
          <span v-if="lot.auctionStatus==0" class="active-lot-time-plan">预计&nbsp;</span>
          <span
              class="active-lot-time-status">{{
              lot.auctionStatus == -1 || lot.auctionStatus == 3 ? lot.endTime + '结束' : meetingData.startAuctionTime + '开始'
            }}</span>
        </span>
        <span v-if="lot.auctionStatus!=null" :style="lot.auctionStatus==0?'background: rgba(30, 169, 106, 1);':
          (lot.auctionStatus==3||lot.auctionStatus==-1?'background: rgba(176, 176, 176, 1);':'')"
              class="active-lot-time-right">
          {{
            lot.auctionStatus == 0 ? '未开始' : (lot.auctionStatus == 1 || lot.auctionStatus == 2 ? '进行中' : (lot.auctionStatus == 3 ? '已成交' : (lot.backOutStatus == 1 ? '已撤拍' : '已流拍')))
          }}</span>
      </div>
      <div>
        <span class="active-lot-bottom-span">{{ lot.viewCount }}次围观</span>
        <span v-if="lot.auctionStatus!=0" class="active-lot-bottom-span">{{ lot.bidCount }}次出价</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LotDivView',
  props: ['lotList', 'meetingData'],
  methods: {
    getPriceUnit(lot) {
      if (!lot) return '元';
      return lot.auctionWay === 1 ? '元' : `元/${lot.unit || ''}`;
    },
    // 判断是否为视频文件
    isVideoFile(url) {
      if (!url) return false;
      const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.avi', '.wmv', '.flv', '.m3u8', '.mkv'];
      const lowerUrl = url.toLowerCase();
      return videoExtensions.some(ext => lowerUrl.endsWith(ext));
    },

    // 视频缩略图加载完成
    onVideoThumbLoaded(lotId, event) {
      const video = event.target;
      // 设置视频当前时间到1秒位置（通常是有效画面）
      video.currentTime = 1;
      // 确保视频静音
      video.muted = true;
    },

    toLotDetail(lot) {
      this.$router.push({
        path: "/lotDetail",
        query: {
          lotId: lot.id,
          meetingData: JSON.stringify(this.meetingData)
        }
      })
    },
  }
}
</script>

<style scoped>
/* 标的数字标签 */
.lot-number-title {
  text-align: center;
  font-size: 26px; /* 字体大小 */
  font-weight: 700; /* 加粗 */
  color: #FF4D4F; /* 红色 */
  margin: 0; /* 上下边距 */
  padding: 8px 0;
  background: rgb(238, 242, 245);
  text-shadow: 2px 2px 4px rgba(255, 255, 255, 0.8); /* 添加白色文字阴影提高可读性 */
}

/* 媒体容器 */
.media-container {
  position: relative;
  width: 310px;
  height: 190px;
  overflow: hidden;
}

/* 视频缩略图包装器 */
.video-thumbnail-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  background: #000;
}

/* 调整图片/视频样式 */
.active-lot-img {
  width: 310px;
  height: 190px;
  opacity: 1;
  margin-top: 0;
  object-fit: cover;
  display: block;
}

/* 调整容器 */
.active-lot-detail {
  display: inline-block;
  width: 310px;
  height: 410px;
  opacity: 1;
  background: rgba(255, 255, 255, 1);
  margin-right: 20px;
  margin-top: 20px;
  overflow: hidden;
}

.active-lot-bottom-span {
  display: inline-block;
  margin: 20px 10px 10px 10px;
  width: 66px;
  height: 18px;
  opacity: 1;
  /** 文本1 */
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 17.38px;
  color: rgba(51, 51, 51, 1);
  text-align: center;
}

.active-lot-time-right {
  display: inline-block;
  width: 60px;
  height: 24px;
  opacity: 1;
  border-radius: 20px 0px 0px 20px;
  background: rgba(214, 54, 59, 1);
  opacity: 1;
  /** 文本1 */
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
}

.active-lot-time-status {
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: NaNpx;
  color: rgba(0, 0, 0, 1);
}

.active-lot-time-plan {
  /** 文本1 */
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 20.27px;
  color: rgba(0, 0, 0, 1);
}

.active-lot-time-left {
  display: inline-block;
  width: 240px;
}

.active-lot-time-div {
  margin-top: 5px;
  margin-left: 10px;
  height: 24px;
}

.acitve-lot-price {
  font-size: 18px;
  font-weight: 400;
}

.active-lot-label-status {
  display: inline-block;
  margin-left: 10px;
  /** 文本1 */
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 26.06px;
  color: rgba(0, 0, 0, 1);
}

.active-lot-name {
  margin: 10px 10px 10px;
  display: block;
  width: 280px;
  min-height: 21px;
  height: auto; /* 自动高度 */
  opacity: 1;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: rgba(0, 0, 0, 1);
  white-space: normal;
  overflow: visible; /* 改为可见 */
  word-wrap: break-word;
  word-break: break-word;
}

.active-lot-sort {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 24px;
  opacity: 1;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1;

  /** 文本1 */
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
}

.cursor-pointer-div:hover {
  cursor: pointer;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.35);
}
</style>
